import React from "react";
import { SvgIcon, SvgIconType } from "@/svg";
import { RadioGroup } from "./RadioGroup";
import type { RadioGroupOption } from "./RadioGroup";
import clsx from "clsx";

export type RadioOptionProps<T extends string> = {
  value: T;
  selectedValue: T;
  icon: SvgIconType;
  label: string;
  onChange: (value: T) => void;
};

export function RadioOption<T extends string>({
  value,
  selectedValue,
  icon,
  label,
  onChange,
}: RadioOptionProps<T>) {
  const [isHovered, setIsHovered] = React.useState(false);
  const isSelected = value === selectedValue;

  return (
    <label
      className="flex items-center justify-between p-2 cursor-pointer text-feintGray"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onChange(value)}
    >
      <div className="flex items-center gap-2">
        <SvgIcon icon={icon} />
        {label}
      </div>
      <span
        className={clsx(
          isSelected && "text-primaryColor",
          !isSelected && isHovered && "text-secondaryColor",
          !isSelected && !isHovered && "text-feintGray",
        )}
      >
        {isSelected ? (
          <SvgIcon icon="RadioFilled" />
        ) : isHovered ? (
          <SvgIcon icon="RadioFilled" />
        ) : (
          <SvgIcon icon="RadioEmpty" />
        )}
      </span>
    </label>
  );
}

export { RadioGroup };
export type { RadioGroupOption };
